import { useTranslation } from 'react-i18next'

const EMAIL = 'zoirjonzokir@gmail.com'
const TELEGRAM = 'zoirjon_sobirov'

// Both avtoturargoh.uz and turargoh.uz serve this same bundle (nginx alias mirror),
// so the offered domain is read from the host the visitor actually arrived on.
const PRIMARY_DOMAIN = 'avtoturargoh.uz'
const ALIAS_DOMAINS = [PRIMARY_DOMAIN, 'turargoh.uz']

function currentDomain(): string {
  if (typeof window === 'undefined') return PRIMARY_DOMAIN
  const host = window.location.hostname.replace(/^www\./, '')
  return ALIAS_DOMAINS.includes(host) ? host : PRIMARY_DOMAIN
}

export function SaleTopbar() {
  const { t } = useTranslation()
  const domain = currentDomain()

  return (
    <div className="border-b border-white/10 bg-[#0a2540] text-white">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-3 px-4 py-2">
        <a href="/" className="whitespace-nowrap text-sm font-bold tracking-tight text-white">
          {domain}
        </a>
        <div className="flex min-w-0 items-center gap-3">
          <span className="whitespace-nowrap rounded-full border border-amber-400/45 bg-amber-400/15 px-2.5 py-1 text-[0.68rem] font-semibold uppercase tracking-[0.09em] text-amber-300">
            {t('sale.tag')}
          </span>
          <span className="hidden truncate text-sm text-slate-300 sm:inline">{t('sale.text')}</span>
          <a
            href={`mailto:${EMAIL}?subject=Offer for ${domain}`}
            className="whitespace-nowrap rounded-lg bg-amber-400 px-4 py-1.5 text-sm font-semibold text-slate-900 transition hover:bg-amber-300"
          >
            {t('sale.cta')}
          </a>
          <a
            href={`https://t.me/${TELEGRAM}`}
            target="_blank"
            rel="noreferrer"
            className="hidden whitespace-nowrap text-sm text-slate-300 hover:text-white md:inline"
          >
            @{TELEGRAM}
          </a>
        </div>
      </div>
    </div>
  )
}
